import Vue from "vue";
import App from "./App.vue";
import "@/assets/css/tailwind.css";
import router from "./router/router";
import { store } from "./store/store";
//import VueGoogleCharts from "vue-google-charts";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
//import VueIntro from "intro.js";
import StarRating from "vue-star-rating";
import VueSweetalert2 from "vue-sweetalert2";
import vmodal from "vue-js-modal";
import ScreenSize from "screen-size-vue";
import KProgress from "k-progress";
import VueEllipseProgress from "vue-ellipse-progress";
Vue.prototype.$Bus = new Vue();
Vue.component("k-progress", KProgress);
import VueConfirmDialog from "vue-confirm-dialog";
//import VueTour from "vue-tour";
import VueCountdownTimer from 'vuejs-countdown-timer'
import Paginate from 'vuejs-paginate'
Vue.use(VueCountdownTimer)
//import Carousel3d from 'vue-carousel-3d';
//Vue.use(Carousel3d);
import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer)
import Pagination from 'laravel-vue-pagination';
import Bugsnag from '@bugsnag/js'
//require("vue-tour/dist/vue-tour.css");
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)

Bugsnag.start({
  apiKey: '183b730b48faac7df20b30aacd1d62dc'
})

Vue.use(Bugsnag);

//Vue.use(VueTour);
Vue.use(VueConfirmDialog);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.component('paginate', Paginate)
Vue.component('pagination', Pagination)

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};
Vue.use(VueSweetalert2, options);
import "@/utils/filters";

// Vue.use(VueIntro, {
//   waitTimeout: 400,
// });

//import "intro.js/introjs.css";
import "./registerServiceWorker";
Vue.use(Datetime);
Vue.use(VueEllipseProgress);
Vue.use(ScreenSize);
Vue.component("star-rating", StarRating);
Vue.use(vmodal);
//Vue.use(VueGoogleCharts);
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;


Vue.filter("str_limit", function(value) {
  if (!value) return "";
  value = value.toString();

  if (value.length <= 150) {
    return value;
  }
  return value.substr(0, 147) + "...";
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
